import * as yup from 'yup'
import { TFunction } from 'react-i18next'

export function buildValidationSchema(t: TFunction): yup.AnyObjectSchema {
  return yup.object().shape({
    name: yup
      .string()
      .label(t('profile.create.modal.name.label'))
      .max(100, ({ label }) =>
        t('validations.maxLength', { label, maxLength: 100 })
      )
      .required(({ label }) => t('validations.required', { label })),
    description: yup
      .string()
      .label(t('profile.create.modal.description.label'))
      .max(250, ({ label }) =>
        t('validations.maxLength', { label, maxLength: 250 })
      )
      .required(({ label }) => t('validations.required', { label })),
  })
}
